module.exports = __webpack_public_path__ + "img/5.33db0a1f.png";